import * as React from 'react';
import { Typography } from '@mui/material';

const unpaidStatusText = `Distribution payments will remain as "Pending" until the payment is issued.
 Once issued, the line item will move to the "Paid" tab.
 All payments, regardless of amount, will be processed by the end of the calendar year.`;

const paidStatusText = (
  <>
    Distribution payments will display as "Issued" until the payment is successfully deposited. Once deposited, the status will update to "Deposited." If a check remains uncashed for 90 days or an electronic transfer fails, the payment will revert to "Pending" and move back to the "Unpaid" tab. If this occurs, please contact <a style={{ color: '#E0D4EC' }} href="mailto:investor.relations@av.vc" target="_blank" rel="noreferrer">investor.relations@av.vc</a> with updated banking or address details.
  </>
);

export default (showUnPaidDistributions) => [
  {
    id: 'datePaid',
    numeric: false,
    disablePadding: false,
    label: 'Date Sent',
    width: '15%',
    sortable: true,
    tooltip: (
      <Typography variant="tooltip">
        The date the distribution was processed for payment.
      </Typography>
    ),
  },
  {
    id: 'fundName',
    numeric: false,
    disablePadding: false,
    label: 'Fund',
    width: '25%',
    sortable: true,
    tooltip: <Typography variant="tooltip">The name of the fund.</Typography>,
  },
  {
    id: 'companyName',
    numeric: false,
    disablePadding: false,
    label: 'Company',
    width: '10%',
    sortable: true,
    tooltip: (
      <Typography variant="tooltip">The name of the portfolio company investment.</Typography>
    ),
  },
  {
    id: 'payee',
    numeric: false,
    disablePadding: false,
    label: 'Payee',
    width: '25%',
    sortable: true,
    tooltip: (
      <Typography variant="tooltip">
        The person or entity to whom the distributions will be paid.
      </Typography>
    ),
  },
  {
    id: 'paymentMethod',
    numeric: false,
    disablePadding: false,
    label: 'Payment Method',
    sortable: true,
    tooltip: <Typography variant="tooltip">The method of payment delivery.</Typography>,
  },
  {
    id: 'issueDate',
    numeric: false,
    disablePadding: false,
    label: 'Issue Date',
    tooltip: (
      <Typography variant="tooltip">
        The date the distribution was processed for payment.
      </Typography>
    ),
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    tooltip: (
      <>
        <Typography variant="tooltip">
          <p>{showUnPaidDistributions ? unpaidStatusText : paidStatusText}</p>
        </Typography>
      </>
    ),
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: 'Amount',
    sortable: true,
    tooltip: (
      <Typography variant="tooltip">
        Amounts paid to you resulting from investment activity.
      </Typography>
    ),
  },
];
